import { Mui, MuiIcons } from "@osu/react-ui";
import { useId } from "react";
import { shallowEqual, useSelector } from "react-redux";
import Paper from "../Paper";
import { selectSubmissionPeriodsOptions } from "../../util/selectors";
import EditSessions from "./Edit/Sessions";
import { getCurrentEasternYear } from "../../../util/functions";
const currentYear = getCurrentEasternYear()

const Accordion = Mui.styled((props) => (
  <Mui.Accordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
}));

function Dates() {
  const years = useSelector(selectSubmissionPeriodsOptions, shallowEqual);
  const baseId = useId()
  const headingId = baseId + `-heading`
  const yearHeadingId = baseId + `-year-heading`;

  return (
    <Paper component="section" aria-labelledby={headingId}>
      <Mui.Box display="flex" justifyContent="space-between" alignItems="flex-end" sx={{ mb: 2 }}>
        <Mui.Typography id={headingId} variant="h2">
          Manage Reporting Periods
        </Mui.Typography>
      </Mui.Box>
      {years.map(({ year }, idx) => {
        const sx = {
          mt: 2
        }
        return (
          <Accordion defaultExpanded={`${year}` === `${currentYear}`} key={`${year}#${idx}`}>
            <Mui.AccordionSummary 
              expandIcon={<MuiIcons.ArrowDownward />}
              aria-labelledby={yearHeadingId} sx={sx}>
              <Mui.Typography
                id={yearHeadingId}
                sx={{ paddingBottom: 2 }}
                variant="h3"
              >
                {year}
              </Mui.Typography>
            </Mui.AccordionSummary>
            <Mui.AccordionDetails sx={{ mx: 4, mb: 1 }} >
              <EditSessions year={year} yearHeadingId={yearHeadingId} baseId={baseId} />
            </Mui.AccordionDetails>
          </Accordion>
        );
      })}
    </Paper>
  );
}

export default Dates;
